import { Injectable, inject } from '@angular/core';
import { MenuAuditLogEntry, MenuAuditLogOptions } from '../../../core/models/domain.models';
import { ApiService } from '../../../core/services/api.service';

export type MenuAuditLogFilters = {
  module_name?: string;
  user_id?: string;
  entity_name?: string;
  action?: string;
  date_from?: string;
  date_to?: string;
  limit?: string;
};

@Injectable({ providedIn: 'root' })
export class MenuAuditLogService {
  private readonly api = inject(ApiService);

  list(filters?: MenuAuditLogFilters) {
    const params = Object.fromEntries(
      Object.entries(filters || {}).filter(([, value]) => value !== undefined && value !== null && String(value).trim() !== ''),
    );
    return this.api.get<MenuAuditLogEntry[]>('/api/menu-audit-logs', params);
  }

  options() {
    return this.api.get<MenuAuditLogOptions>('/api/menu-audit-logs/options');
  }

  logEvent(payload: {
    module_name: string;
    entity_type: string;
    entity_id: string;
    entity_name?: string | null;
    action: string;
    old_data?: Record<string, unknown> | null;
    new_data?: Record<string, unknown> | null;
  }) {
    return this.api.post<{ message: string }>('/api/menu-audit-logs/events', payload);
  }
}
